/** @format */

import { instance } from './instance';

export type ImageGenerationEntityType =
  | 'FOOD_ITEM'
  | 'BRAND_LOGO'
  | 'BRAND_BANNER'
  | 'BRAND_THUMBNAIL'
  | 'CATEGORY'
  | 'BANNER';

export type ImageGenerationStatus =
  'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';

export interface CreateImageJobPayload {
  entityType: ImageGenerationEntityType;
  subject: string;
  entityId?: string;
  model?: string;
  size?: string;
  quality?: string;
  n?: number;
}

export interface ImageGenerationJob {
  id: string;
  entityType: ImageGenerationEntityType;
  entityId: string | null;
  subject: string;
  finalPrompt: string;
  model: string;
  size: string | null;
  quality: string | null;
  n: number;
  status: ImageGenerationStatus;
  resultUrls: string[];
  error: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ImageJobList {
  data: ImageGenerationJob[];
  total: number;
  page: number;
  count: number;
}

// Backend wraps all responses via a global SerializeInterceptor (response.data.data).
export const createImageJob = async (
  payload: CreateImageJobPayload,
): Promise<ImageGenerationJob> => {
  const { data } = await instance.post('/image-generation', payload);
  return data.data;
};

export const getImageJob = async (id: string): Promise<ImageGenerationJob> => {
  const { data } = await instance.get(`/image-generation/${id}`);
  return data.data;
};

export const listImageJobs = async (
  page = 1,
  count = 20,
): Promise<ImageJobList> => {
  const { data } = await instance.get('/image-generation', {
    params: { page, count },
  });
  return data.data;
};
